const userReducer = (state = {}, action) => {
  switch (action.type) {
    case 'USER':
      return action.data
    default:
      return state
  }
}

export default userReducer
